import { Button, Modal } from "antd";
import { useStrategy } from "./useCreateStrategyContext";
import styles from "../../../styles/Components/new-insight/create-strategy/AddStrategy.module.css";
import { useDispatch, useSelector } from "react-redux";
import {
  createStrategyPack,
  editStrategy,
} from "../../../redux/new-insight/actions";
import useUserData from "../../../hooks/useUserData";
import { arraysAreEqual } from "../../../utility/helper";
import { FaQuestionCircle } from "react-icons/fa";

function AddStrategy({ setStep }) {
  const {
    newInsightState: { createStrategyStatus, createStrategyResult, insightMarketType },
  } = useSelector((state) => state);

  const {
    state: { strategyList, mode, selectedFeatures, initialFeatures },
  } = useStrategy();

  const { username, email } = useUserData();

  const dispatch = useDispatch();

  const clickHandler = () => {
    if (mode === "edit") {
      if (arraysAreEqual(initialFeatures, selectedFeatures)) {
        return Modal.info({
          title: "No changes detected!",
          content: "Please update at least one feature to continue.",
          okButtonProps: {
            style: {
              backgroundColor: "#0c4cfc",
              borderColor: "#0c4cfc",
            },
          },
          centered: true,
        });
      }
    }

    if (
      mode === "edit-create" &&
      arraysAreEqual(
        strategyList,
        JSON.parse(createStrategyResult?.list_feature_info),
      )
    ) {
      return setStep(2);
    }

    Modal.confirm({
      title: "Confirmation",
      content:
        "Have you chosen all data metrics? Click Yes to proceed, or No to add more.",
      okText: "Yes",
      cancelText: "No",
      okButtonProps: {
        style: {
          backgroundColor: "#0c4cfc",
          borderColor: "#0c4cfc",
        },
      },
      icon: (
        <FaQuestionCircle
          size={25}
          style={{ marginRight: "8px" }}
          color="#0c4cfc"
        />
      ),
      centered: true,
      onOk: () => {
        const createdDate = mode?.includes("edit")
          ? createStrategyResult?.createdDate
          : null;
        dispatch(
          createStrategyPack(
            username,
            email,
            insightMarketType || "crypto",
            strategyList,
            "",
            createdDate,
          ),
        );

        // if (mode?.includes("edit")) {
        //   if (mode === "edit-create") {
        //     if (
        //       !arraysAreEqual(
        //         strategyList,
        //         JSON.parse(createStrategyResult?.list_feature_info),
        //       )
        //     ) {
        //       const featuresString = JSON.stringify(strategyList);
        //       const changedValues = [featuresString];
        //
        //       dispatch(
        //         editStrategy(
        //           username,
        //           email,
        //           createStrategyResult?.createdDate,
        //           ["list_feature_info"],
        //           changedValues,
        //           false,
        //         ),
        //       );
        //     } else {
        //       setStep(2);
        //     }
        //   }
        // } else {
        //   dispatch(
        //     createStrategyPack(
        //       username,
        //       email,
        //       "crypto",
        //       // strategy_name,
        //       // strategy_label,
        //       // strategy_tag,
        //       strategyList,
        //     ),
        //   );
        // }
        setStep(2);
      },
      onCancel: () => Modal.destroyAll(),
    });
  };

  return (
    <div className={styles.container}>
      <Button
        disabled={!strategyList.length}
        loading={createStrategyStatus === "loading"}
        onClick={clickHandler}
      >
        {mode === "edit" ? "Next" : "Create Strategy"}
      </Button>
      <span>{strategyList.length} items selected</span>
    </div>
  );
}

export default AddStrategy;
